import { render, staticRenderFns } from "./actions.vue?vue&type=template&id=5572a09c"
import script from "./actions.vue?vue&type=script&lang=js"
export * from "./actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5572a09c')) {
      api.createRecord('5572a09c', component.options)
    } else {
      api.reload('5572a09c', component.options)
    }
    module.hot.accept("./actions.vue?vue&type=template&id=5572a09c", function () {
      api.rerender('5572a09c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/companies/components/actions.vue"
export default component.exports